import { OperationVariables } from '@apollo/client';
import { useQuery } from "@apollo/client/react";
import { GET_CLIENT_MESSAGING_VISIBILITY } from '../graphql/resolvers/queries';

export interface UseClientMessagingVisibilityProps {
    options?: useQuery.Options<{ getClientMessagingVisibility: boolean }, OperationVariables>;
}

const useClientMessagingVisibility = ({ options }: UseClientMessagingVisibilityProps = {}) => {
    const { data, loading, error } = useQuery<{ getClientMessagingVisibility: boolean }>(
        GET_CLIENT_MESSAGING_VISIBILITY,
        { ...options }
    );

    return {
        isMessagingEnabled: data?.getClientMessagingVisibility ?? (options?.skip ? true : false),
        loading,
        error,
    };
};

export default useClientMessagingVisibility;
